import { useEffect } from "react";
import { useState } from "react";
export const useIP = () => {
  const [ip, setIp] = useState("-");
  useEffect(() => {
    fetch("https://api.ipify.org?format=json").then((res) => {
      res.json().then((content) => {
        setIp(content.ip);
      });
    });
  }, []);
  return [ip];
};
